// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"980fbd8e","276":"5f6245f4","308":"144c1050","332":"92f9b184","422":"72925f90","453":"b9e64f82","545":"cdab2498","796":"af854d90","843":"bb4a1382"}[chunkId] + ".chunk.js";
};